import type { LocalizationSettings } from '../../services/localizationApi';

/**
 * M5 (AB#924): tenant'ın presentation katmanı için göstereceği ondalık basamak sayısı
 * range + default'u. Backend `Beetegre.Domain.Localization.DisplayFractionDigitsRange`
 * ile bire-bir kavramsal parite — değer değişirse iki yer birlikte güncellenmeli.
 *
 * Storage decimal places ISO 4217 sabit kalır; bu değer SADECE `formatCurrency` /
 * `formatNumber` çağrılarına yansır.
 */
export const DISPLAY_FRACTION_DIGITS = {
  min: 2,
  max: 4,
  default: 2,
} as const;

/** Select / dropdown seçenekleri için `[min..max]` tuple'ı — single source of truth. */
export const DISPLAY_FRACTION_DIGIT_OPTIONS: readonly number[] = Object.freeze(
  Array.from(
    { length: DISPLAY_FRACTION_DIGITS.max - DISPLAY_FRACTION_DIGITS.min + 1 },
    (_, i) => DISPLAY_FRACTION_DIGITS.min + i,
  ),
);

/**
 * Default localization settings used when the persisted AuthUser predates the
 * localizationSettings field (migration concern: old localStorage objects may
 * not carry this field). Kept in sync with backend SupportedLanguages.Turkish /
 * SupportedCurrencies.TRY / SupportedTimezones.Istanbul defaults.
 */
export const DEFAULT_LOCALIZATION: LocalizationSettings = {
  language: 'tr',
  currency: 'TRY',
  timezone: 'Europe/Istanbul',
  dateFormat: 'dd.MM.yyyy',
  decimalSeparator: ',',
  thousandsSeparator: '.',
  // M5 (AB#924): display-only fraction digits — backend default 2 ile aynı.
  displayFractionDigits: DISPLAY_FRACTION_DIGITS.default,
};
